import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HelperService } from './../services/helper.service';
import {ContactService } from './../rest/api/contact.service';
import { SettingService } from './../rest/api/setting.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  contactForm: FormGroup;
  isSubmitting = false;
  isSubmitted = false;
  contactAddress: any;

  errors = [];
  successMsg: string;
  errorMsg: string;

  constructor(
    public fb: FormBuilder,
    public helperService: HelperService,
    public contactService: ContactService,
    public settingService: SettingService,
    public router: Router,
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        // trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
        // if you need to scroll back to top, here is the right place
        window.scrollTo(0, 0);
      }
    });
  }

  ngOnInit() {
    this.contactFormInit();
    this.getContactAddress();
  }

  contactFormInit() {
    this.contactForm = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(40)]],
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')]],
      message: ['', [Validators.required, Validators.maxLength(300)]]
    });
  }

  submit(value) {
    if (!this.contactForm.valid) {
      this.isSubmitting = true;
      return;
    }
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    this.resetErrors();
    const data = value;
    this.contactDetail(data);
  }

  resetErrors() {
    this.successMsg = undefined;
    this.errorMsg = undefined;
    this.errors = [];
  }


  contactDetail(data) {
    const formData = {
      name: data.name,
      email: data.email,
      message: data.message
    };
    const d = this.helperService.updateJsonFormat(formData);
    this.contactService.postContact(d).subscribe((response: any) => {
      this.resetForm();
      this.successMsg = 'Thank You! We have received your message and will get back to you shortly.';
      setTimeout(() => {
        this.resetErrors();
      }, 5000);
    }, err => {
      this.handleErrors(err);
    });
  }

  getContactAddress() {
    this.settingService. getSettingDetails().subscribe((response: any) => {
      this.contactAddress = response.data;
    }, err => {
      console.log(err && err.error);
    });
  }

  resetForm() {
    this.isSubmitted = false;
    this.isSubmitting = false;
    this.contactForm.reset();
  }

  handleErrors(err) {
    if (err.error && err.error.errors) {
      this.errors = err.error.errors;
    } else if (err.error && err.error.error) {
      this.errorMsg = err.error.error;
    } else {
      this.errorMsg = 'Unable to register at this time.';
    }
    this.isSubmitted = false;
    this.isSubmitting = false;
    setTimeout(() => {
      this.resetErrors();
    }, 5000);
  }

  getEmbedUrl() {
    return `https://maps.google.com/maps?q=${this.contactAddress.latitude},${this.contactAddress.longitude}&z=15&output=embed`;
  }

}
